import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const ProductGrid = ({ products, onEditProduct, onDeleteProduct }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [editingProduct, setEditingProduct] = useState(null);
  const [editValues, setEditValues] = useState({});

  const filteredProducts = products.filter(product =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    product.category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleEditStart = (product) => {
    setEditingProduct(product.id);
    setEditValues({
      price: product.price,
      inventory: product.inventory
    });
  };

  const handleEditSave = (productId) => {
    onEditProduct(productId, editValues);
    setEditingProduct(null);
    setEditValues({});
  };

  const handleEditCancel = () => {
    setEditingProduct(null);
    setEditValues({});
  };

  const getStatusBadge = (inventory) => {
    if (inventory > 50) {
      return <span className="px-2 py-1 text-xs font-medium bg-success/10 text-success rounded-full">In Stock</span>;
    } else if (inventory > 0) {
      return <span className="px-2 py-1 text-xs font-medium bg-warning/10 text-warning rounded-full">Low Stock</span>;
    } else {
      return <span className="px-2 py-1 text-xs font-medium bg-error/10 text-error rounded-full">Out of Stock</span>;
    }
  };

  return (
    <div className="space-y-6">
      {/* Search and Filter Bar */}
      <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
        <div className="flex-1 max-w-md">
          <Input
            type="search"
            placeholder="Search products..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full"
          />
        </div>
        <div className="flex items-center space-x-2">
          <Button variant="outline" iconName="Filter" iconPosition="left" iconSize={16}>
            Filter
          </Button>
          <Button variant="outline" iconName="Download" iconPosition="left" iconSize={16}>
            Export
          </Button>
        </div>
      </div>

      {/* Products Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredProducts.map((product) => (
          <div key={product.id} className="bg-card border border-border rounded-lg p-6 micro-animation hover:shadow-sm">
            <div className="flex items-start justify-between mb-4">
              <div className="flex-1">
                <h3 className="font-semibold text-foreground mb-1">{product?.name}</h3>
                <p className="text-sm text-muted-foreground mb-2">{product.category}</p>
                {/* {getStatusBadge(product.inventory)} */}
              </div>
              {/* <div className="flex items-center space-x-1">
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => handleEditStart(product)}
                  disabled={editingProduct === product.id}
                >
                  <Icon name="Edit2" size={16} />
                </Button>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => onDeleteProduct(product.id)}
                  className="text-error hover:text-error"
                >
                  <Icon name="Trash2" size={16} />
                </Button>
              </div> */}
            </div>




...



            <div className="space-y-3">
              {editingProduct === product.id ? (
                <>
                  <div>
                    <Input
                      label="Price"
                      type="number"
                      value={editValues.price}
                      onChange={(e) => setEditValues({...editValues, price: parseFloat(e.target.value)})}
                      placeholder="0.00"
                    />
                  </div>
                  <div>
                    <Input
                      label="Inventory"
                      type="number"
                      value={editValues.inventory}
                      onChange={(e) => setEditValues({...editValues, inventory: parseInt(e.target.value)})}
                      placeholder="0"
                    />
                  </div>
                  <div className="flex space-x-2">
                    <Button
                      variant="default"
                      size="sm"
                      onClick={() => handleEditSave(product.id)}
                      iconName="Check"
                      iconPosition="left"
                      iconSize={14}
                    >
                      Save
                    </Button>
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={handleEditCancel}
                      iconName="X"
                      iconPosition="left"
                      iconSize={14}
                    >
                      Cancel
                    </Button>
                  </div>
                </>
              ) : (
                <>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-muted-foreground">Price</span>
                    <span className="font-semibold text-foreground">${product?.price?.toFixed(2)}</span>
                  </div>
                  {/* <div className="flex justify-between items-center">
                    <span className="text-sm text-muted-foreground">Inventory</span>
                    <span className="font-medium text-foreground">{product.inventory} units</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-muted-foreground">Sales</span>
                    <span className="font-medium text-foreground">{product.totalSales}</span>
                  </div> */}
                </>
              )}
            </div>
          </div>
        ))}
      </div>

      {filteredProducts.length === 0 && (
        <div className="text-center py-12">
          <Icon name="Package" size={48} className="mx-auto text-muted-foreground mb-4" />
          <h3 className="text-lg font-medium text-foreground mb-2">No products found</h3>
          <p className="text-muted-foreground">
            {searchTerm ? "Try adjusting your search terms" : "Start by adding your first product"}
          </p>
        </div>
      )}
    </div>
  );
};

export default ProductGrid;